import { atom } from 'jotai';
import { loadable } from 'jotai/utils';
import request from 'lib/request';
import type { OrphanedSubtractGeometriesResponse } from './types';

const orphanedGeometriesBaseAtom = atom(async () => {
  const response = await request.get<OrphanedSubtractGeometriesResponse>(
    '/admin/orphaned_subtract_geometries'
  );
  if ('error' in response) {
    throw new Error(response.error);
  }
  return response;
});

export const orphanedGeometriesLoadableAtom = loadable(
  orphanedGeometriesBaseAtom
);
